import Icon from 'veui/components/Icon'
import { IconTelephone } from 'dls-icons-vue'

Icon.register('telephone', IconTelephone)
